/**
 * NjitTextfield behaviour.
 */

(function (Drupal, $) {
  "use strict";

  Formstone.NoConflict();

  Drupal = Drupal || {};

  Drupal.settings = Drupal.settings || {};

  Drupal.behaviors.NjitTextfield = {
    attach: function (context, settings) {
      $("input[type='text'].error").parent().find('label:not(.error)').addClass('error');
    }
  }

})(Drupal, jQuery);
